<template>
  <div
    class="ticket-transfer-report pa-4"
    :class="{ 'ticket-transfer-report--dark': isDark }"
  >

  <!--=========================================================================  -->
    <!-- filteration section and total count of transfers -->
    <v-card elevation="1" class="pa-4 mb-4">
      <v-row align="center">
        <v-col cols="12" md="3">
          <PickerInput label="من تاريخ" @dateValue="startDate = $event" />
        </v-col>
        <v-col cols="12" md="3">
          <PickerInput label="إلى تاريخ" @dateValue="endDate = $event" />
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            v-model="userType"
            :items="userTypeOptions"
            item-text="text"
            item-value="value"
            label="نوع المستخدم"
            outlined
            dense
            hide-details
            class="ticket-transfer-report__user-type"
          />
        </v-col>
        <v-col cols="12" md="3" class="d-flex align-center">
          <v-btn color="#3f0e40" dark depressed :loading="loading" @click="loadReport">
            عرض التقرير
          </v-btn>
          <v-btn
            outlined
            class="mr-2 ticket-transfer-report__reset-btn"
            @click="resetFilters"
          >
            مسح
          </v-btn>
        </v-col>
        <v-col cols="12" class="text-left">
          <span class="font-weight-bold ticket-transfer-report__total">
            إجمالي التحويلات: {{ displayTotalTransfers }}
          </span>
        </v-col>
      </v-row>
    </v-card>
  <!--=========================================================================  -->

  <!--=========================================================================  -->
    <!-- table of transfers -->
    <v-card elevation="1">
      <v-card-text class="pb-0">
        <v-autocomplete
          v-model="selectedUser"
          :items="userPickerItems"
          :search-input.sync="nameFilter"
          item-text="user_name"
          return-object
          clearable
          outlined
          dense
          hide-details
          hide-no-data
          label="اسم المستخدم"
          placeholder="ابحث أو اختر مستخدماً"
          class="ticket-transfer-report__name-filter mb-3"
          @change="onUserPicked"
          @click:clear="onUserFilterClear"
        />
      </v-card-text>
      <v-data-table
        :headers="headers"
        :items="displayRows"
        :loading="loading"
        loading-text="جاري التحميل..."
        no-data-text="لا توجد تحويلات"
        hide-default-footer
        disable-pagination
        class="elevation-0 ticket-transfer-report__table"
      >
        <template #[`item.transfers_count`]="{ item }">
          <button
            type="button"
            class="ticket-transfer-report__count-btn"
            @click="openDetails(item)"
          >
            {{ item.transfers_count }}
          </button>
        </template>
      </v-data-table>
    </v-card>
  <!--=========================================================================  -->

  <!--=========================================================================  -->
    <!-- details dialog -->
    <v-dialog v-model="detailsDialog" max-width="900" scrollable>
      <v-card :class="{ 'ticket-transfer-report--dark': isDark }">
        <v-card-title class="d-flex justify-space-between align-center ticket-transfer-report__dialog-title">
          <span>تحويلات {{ selectedUserName }} ({{ selectedUserTypeLabel }})</span>
          <v-btn icon class="ticket-transfer-report__close-btn" @click="detailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text style="max-height: 420px">
          <v-data-table
            :headers="detailHeaders"
            :items="detailItems"
            :loading="detailsLoading"
            loading-text="جاري التحميل..."
            no-data-text="لا توجد تذاكر"
            hide-default-footer
            disable-pagination
            class="elevation-0 ticket-transfer-report__table"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  <!--=========================================================================  -->

  </div>
</template>

<script>
import { axiosInstance } from "@/axios/config";
import PickerInput from "@/components/AdminComponent/PickerInput.vue";

export default {
  name: "TicketTransferReport",
  components: { PickerInput },
  data() {
    return {
      loading: false,
      detailsLoading: false,
      startDate: null,
      endDate: null,
      userType: "both",
      nameFilter: "",
      selectedUser: null,
      selectedUserId: null,
      userTypeOptions: [
        { text: "الاستشاري وخدمة العملاء", value: "both" },
        { text: "الاستشاري فقط", value: "agent" },
        { text: "خدمة العملاء فقط", value: "cs" },
      ],
      totalTransfers: 0,
      rows: [],
      headers: [
        { text: "#", value: "index", align: "center", sortable: false, width: "60px" },
        { text: "المستخدم", value: "user_name", align: "center" },
        { text: "نوع المستخدم", value: "user_type_label", align: "center" },
        { text: "عدد التحويلات للادمن", value: "transfers_count", align: "center" },
      ],
      detailsDialog: false,
      selectedUserName: "",
      selectedUserTypeLabel: "",
      detailItems: [],
      detailHeaders: [
        { text: "رقم التذكرة", value: "task_id", align: "center" },
        { text: "رقم الطلب", value: "req_id", align: "center" },
        { text: "العميل", value: "customer_name", align: "center" },
        { text: "الجوال", value: "customer_mobile", align: "center" },
        { text: "تاريخ التحويل", value: "transferred_at", align: "center" },
      ],
    };
  },
  mounted() {
    this.loadReport();
  },
  computed: {
    isDark() {
      return this.$store.getters.isDark;
    },
    userPickerItems() {
      const q = (this.nameFilter || "").trim().toLowerCase();
      const source = this.rows || [];
      if (!q) {
        return source;
      }
      return source.filter((row) =>
        (row.user_name || "").toLowerCase().includes(q)
      );
    },
    displayRows() {
      const q = (this.nameFilter || "").trim().toLowerCase();
      let list = this.rows || [];
      if (q && !this.selectedUserId) {
        list = list.filter((row) =>
          (row.user_name || "").toLowerCase().includes(q)
        );
      }
      return list.map((row, index) => ({
        ...row,
        index: index + 1,
      }));
    },
    displayTotalTransfers() {
      if (this.selectedUserId) {
        return this.totalTransfers;
      }
      return this.displayRows.reduce(
        (sum, row) => sum + (row.transfers_count || 0),
        0
      );
    },
  },
  watch: {
    userType() {
      this.loadReport();
    },
  },
  methods: {
    //=========================================================================  -->
    // build params
    //=========================================================================  -->
    buildParams() {
      const params = { user_type: this.userType || "both" };
      if (this.startDate) params.start_date = this.startDate;
      if (this.endDate) params.end_date = this.endDate;
      if (this.selectedUserId) params.user_id = this.selectedUserId;
      return params;
    },
    //=========================================================================  -->
    // reset filters
    //=========================================================================  -->
    resetFilters() {
      this.startDate = null;
      this.endDate = null;
      this.userType = "both";
      this.nameFilter = "";
      this.selectedUser = null;
      this.selectedUserId = null;
      this.loadReport();
    },
    onUserPicked(user) {
      if (user && user.user_id) {
        console.log("user: ", user);
        this.selectedUserId = user.user_id;
        this.selectedUser = user;
        this.nameFilter = user.user_name || "";
        console.log("buildParams: ", this.buildParams());
        this.loadReport();
        return;
      }
      this.onUserFilterClear();
    },
    onUserFilterClear() {
      this.selectedUser = null;
      this.selectedUserId = null;
      this.nameFilter = "";
      this.loadReport();
    },
    loadReport() {
      this.loading = true;
      axiosInstance
        .get("/employee/admin/Task/AdminTransferReport", { params: this.buildParams() })
        .then((res) => {
          const payload = res.data.payload || {};
          this.totalTransfers = payload.total_transfers || 0;
          this.rows = payload.rows || [];
        })
        .catch(() => {
          this.$store.commit("showPopup", {
            type: "error",
            message: "تعذر تحميل التقرير",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //=========================================================================  -->
    // open details dialog
    //=========================================================================  -->
    openDetails(item) {
      this.selectedUserName = item.user_name;
      this.selectedUserTypeLabel = item.user_type_label || "";
      this.detailsDialog = true;
      this.detailsLoading = true;
      this.detailItems = [];

      axiosInstance
        .get(`/employee/admin/Task/AdminTransferReport/${item.user_id}`, {
          params: this.buildParams(),
        })
        .then((res) => {
          this.detailItems = res.data.payload?.items || [];
          if (res.data.payload?.user_name) {
            this.selectedUserName = res.data.payload.user_name;
          }
          if (res.data.payload?.user_type_label) {
            this.selectedUserTypeLabel = res.data.payload.user_type_label;
          }
        })
        .catch(() => {
          this.$store.commit("showPopup", {
            type: "error",
            message: "تعذر تحميل تفاصيل التحويلات",
          });
        })
        .finally(() => {
          this.detailsLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.ticket-transfer-report {
  min-height: 400px;
}

.ticket-transfer-report__total,
.ticket-transfer-report__dialog-title span {
  color: #1f2937;
}

.ticket-transfer-report__reset-btn {
  color: #3f0e40 !important;
  border-color: #3f0e40 !important;
  background-color: #fff !important;
}

.ticket-transfer-report__count-btn {
  color: #3f0e40;
  font-weight: 700;
  font-size: 15px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  padding: 4px 8px;
}

.ticket-transfer-report__count-btn:hover {
  color: #2a0a2b;
}

.ticket-transfer-report__close-btn .v-icon {
  color: #2c2c2c !important;
}

.ticket-transfer-report ::v-deep .ticket-transfer-report__table th {
  color: #1f2937 !important;
}

.ticket-transfer-report ::v-deep .ticket-transfer-report__table tbody td {
  color: #374151;
}

.ticket-transfer-report--dark .ticket-transfer-report__total,
.ticket-transfer-report--dark .ticket-transfer-report__dialog-title span {
  color: #f3f4f6 !important;
}

.ticket-transfer-report--dark .ticket-transfer-report__reset-btn {
  color: #f3f4f6 !important;
  border-color: #9ca3af !important;
  background-color: transparent !important;
}

.ticket-transfer-report--dark .ticket-transfer-report__count-btn {
  color: #e9d5ff;
}

.ticket-transfer-report--dark .ticket-transfer-report__count-btn:hover {
  color: #fff;
}

.ticket-transfer-report--dark .ticket-transfer-report__close-btn .v-icon {
  color: #f3f4f6 !important;
}

.ticket-transfer-report--dark ::v-deep .ticket-transfer-report__table th {
  color: #f3f4f6 !important;
}

.ticket-transfer-report--dark ::v-deep .ticket-transfer-report__table tbody td {
  color: #e5e7eb;
}
</style>
